import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { Button } from './Button';
const painPoints = ['Tenés un buen producto o servicio, pero casi nadie lo conoce online.', 'Publicás en redes, pero no conseguís clientes ni ventas constantes.', 'Probaste hacer anuncios y sentiste que solo perdiste plata.', 'Te escriben por WhatsApp, preguntan precio… y después desaparece.', 'Ves que otros venden por internet y no entendés qué están haciendo distinto.', 'Querés usar IA para vender mejor, pero no sabés por dónde empezar.', 'Sabés que internet puede hacer crecer tu negocio, pero hoy sentís que te falta un sistema claro.'];
export function PainPoints() {
  return <section className="py-10 sm:py-16 px-4 bg-green-950/40 border-y border-green-700/20" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-162">
          <h2 className="text-3xl sm:text-4xl font-black text-center text-white mb-6 sm:mb-10 drop-shadow-lg uppercase" data-id="element-163">
            ¿TE PASA ALGUNA DE ESTAS COSAS?
          </h2>

          <div className="space-y-3 mb-8" data-id="element-164">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-green-950/50 p-5 rounded-xl border border-green-700/20" data-id="element-165">
                <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-166" />
                <p className="text-lg text-white font-medium" data-id="element-167">{point}</p>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-168">
            <Button href="https://checkout.guiadigital360.online/cart/44839939866693:1" className="mx-auto" data-id="element-169">
              🔥 QUIERO RESOLVER ESTO AHORA
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}